module.exports = __webpack_public_path__ + "06cbb004da4a6c7c154e482e3f3930df.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/shoes-high-heels-pink.png
// module id = 2430
// module chunks = 0